<template>
<div>
  <div class="card-title h5">2. {{ $t('tabs.photo.title') }}</div>
  <div class="row">
    <div class="col col-12">
      <div class="row">
          <b-tabs v-if="!url">
            <b-tab active @click="selectUploadPhotoTab">
              <template #title>
                <div class="tab-title"><i class="fas fa-cloud-arrow-up fa-xl mr-2"></i> {{ $t('tabs.photo.upload_photo') }}</div>
              </template>
              <div class="mt-2">
                <upload-avatar @takedPhoto="handlePhotoTaken" v-if="!url"/>
              </div>
            </b-tab>

            <b-tab @click="selectWebcamTab">
              <template #title>
                <div class="tab-title"><i class="fas fa-camera fa-xl mr-2"></i> {{ $t('tabs.photo.make_photo') }}</div>
              </template>
              <div class="mt-2">
                <web-cam @takedPhoto="handlePhotoTaken" v-if="!url && webcamSelected"/>
              </div>
            </b-tab>
          </b-tabs>

          <div v-if="url">
            <div id="preview">
              <show-carnet :nom="nom" :estudi="estudi" :url="url" />
            </div>
            <div class="text-center p-4">
              <button type="button" class="btn btn-danger" @click.prevent="removePhoto"><i class="fas fa-close"></i> {{ $t('tabs.photo.remove_photo')}}</button>
            </div>
        </div>

        <span class="my-invalid-feedback" v-show="errorNoFoto" v-html="$t('tabs.photo.errors.no_foto')"></span>
        <span class="my-invalid-feedback" v-show="errors.has('fotografia')">{{ errors.first('fotografia') }}</span>
          <ul>
            <li v-for="(error,index) in errors.all()" :key="index" class="invalid-feedback">{{ error }}</li>
          </ul>
      </div>
    </div>
    <div class="col col-12">
      <strong>{{ $t('tabs.photo.intro') }}</strong>
      <br/><br/>
      {{ $t('tabs.photo.requirements_title') }}
      <ul>
        <li v-for="(requirement, idx) in $t('tabs.photo.requirements')" v-bind:key="idx" v-html="requirement"></li>
      </ul>
      <p>{{ $t('tabs.photo.note') }}</p>
    </div>
  </div>

</div>
</template>

<script>

import ShowCarnet from "@/components/commons/ShowCarnet.vue";
import UploadAvatar from "@/components/commons/UploadAvatar.vue";
import WebCam from "@/components/commons/WebCam.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
    name: 'Foto',
    components: {WebCam, UploadAvatar, ShowCarnet},
    data() {
      return {
        webcamSelected: false,
        fotografia: null,
        errorNoFoto: false,
        url: null,
        nom: '',
        estudi: '',
      }
    },
    mounted() {
      this.$root.$on('get-nom', (nom) => {
        this.nom = nom
      });
      this.$root.$on('get-estudi', (estudi) => {
        this.estudi = estudi
      });
    },
    methods: {
        async validate() {

          const result = await this.$validator.validateAll();
          if (!result) {
            return false;
          }
          this.$emit('on-validate', this.$data, true);
          return result;
        },
        handlePhotoTaken(imageData) {
          this.fotografia = imageData;
          this.url = URL.createObjectURL(imageData);
        },
        removePhoto() {
          this.fotografia = null;
          this.url = null;
        },
        selectWebcamTab() {
          this.webcamSelected = true;
        },
        selectUploadPhotoTab() {
          this.webcamSelected = false;
        },
    }
}
</script>

<style scoped>
  #preview {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #preview img {
    max-width: 100%;
    max-height: 500px;
  }

  .tab-title {
    margin: 1.5em 3em;
    color: #333 !important;
  }

  .mr-2 {
    margin-right: 0.3em;
  }
</style>